import axios from 'axios';
import config from '../config';

const baseurl = config.api[config.stage].baseurl;

class FeaturesProvider {
    static async getAll() {
        const url = `${baseurl}features`;
        return await axios({
            url,
            method: 'GET',
            crossdomain: true,
            mode: 'no-cors',
        })
        .then((json) => json.data)
        .then((res) => res)
        .catch((err) => {
          if (err.response) return err.response.data;
          return err;
        });
    }
}

export default FeaturesProvider;
